const Slugify = require('slugify')

export default function ({ app }, inject) {
  inject('slugify', (item) => {
    if (item) {
      return Slugify(item, { remove: "'" })
    }
  })
}
